import { useEffect, useState } from 'react';
import dayjs from 'dayjs';

const MINUTE_IN_MILLISECONDS = 60000;

const useTimer = (callback, active, timeout = MINUTE_IN_MILLISECONDS) => {
  // state variable to re-mount when needed
  const [ startTime, setStartTime ] = useState(dayjs());

  useEffect(() => {
    if (!active) {
      return;
    }
    const intervalId = setInterval(() => callback(), timeout);
    return () => clearInterval(intervalId);
  }, [ startTime.toISOString(), active ]);

  // Hacky way to do the reset by new timestamp
  return () => setStartTime(dayjs());
};

export default useTimer;

